module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/simplebar/node_modules/core-js/internals/iterators.js
// module id = 61
// module chunks = 0